import React from 'react';

import './style.sass';

type Props = React.PropsWithChildren;

export const LoaderLayout = ({ children }: Props) => {
    return (
        <div className="loader-layout">
            {children}
        </div>
    );
};
